// extracted by mini-css-extract-plugin
export var gif = "_jo-0";